<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center gap-3 mb-2">
      <a routerLink="/dashboard/config" class="p-2 hover:bg-gray-200 rounded-lg transition-colors">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </a>
      <div class="p-2 bg-blue-500 rounded-lg">
        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Logs de Conciliación</h1>
        <p class="text-gray-500 text-sm">Historial de ejecuciones del proceso de conciliación automática</p>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
    <div class="flex flex-wrap items-end gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
        <input type="date" 
               [(ngModel)]="dateFrom"
               class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
        <input type="date" 
               [(ngModel)]="dateTo"
               class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
      <button (click)="applyFilters()" 
              class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        Filtrar
      </button>
      <button (click)="clearFilters()" 
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors">
        Limpiar
      </button>
    </div>
  </div>

  <!-- Logs Table -->
  <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Ejecución</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Procesados</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conciliados</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fallidos</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pendientes</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duración</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let log of logs" class="hover:bg-gray-50 cursor-pointer" (click)="viewLogDetail(log)">
            <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-blue-600">
              #{{ log.id }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ formatDate(log.executionDate) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 font-medium">
              {{ log.totalProcessed }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span class="text-sm font-medium text-green-600">{{ log.totalConciliated }}</span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span class="text-sm font-medium" [class.text-red-600]="log.totalFailed > 0" [class.text-gray-500]="log.totalFailed === 0">
                {{ log.totalFailed }}
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span class="text-sm font-medium text-amber-600">{{ log.totalPending }}</span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="getStatusBadgeClasses(log.status)">
                {{ log.statusName }}
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ formatDuration(log.executionTimeMs) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span *ngIf="log.emailNotificationSent" class="text-green-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span *ngIf="!log.emailNotificationSent" class="text-gray-400">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <button (click)="viewLogDetail(log); $event.stopPropagation()" 
                      class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Ver detalle
              </button>
            </td>
          </tr>
          <tr *ngIf="logs.length === 0">
            <td colspan="10" class="px-4 py-8 text-center text-gray-500">
              No se encontraron logs de conciliación
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
